import React, { useState } from 'react';
import PropTypes from 'prop-types';
import WebRTCDemo from '../WebRTCDemo';
import MinimizedView from './MinimizedView';
import ExpandedModal from './ExpandedModal';

/**
 * Header Demo Widget - KISS Implementation
 * 
 * Simple two-state widget:
 * 1. Minimized: Polished header button
 * 2. Expanded: Modal containing existing WebRTC component (auto-starts connection)
 */
const HeaderDemoWidget = ({ 
  userName = 'User',
  onConversationStart,
  onConversationEnd,
  onError
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldAutoStart, setShouldAutoStart] = useState(false);

  const handleToggle = () => {
    if (!isExpanded) {
      // When opening the modal, prepare to auto-start the connection
      setShouldAutoStart(true);
    }
    setIsExpanded(!isExpanded);
  };

  const handleClose = () => {
    setIsExpanded(false);
    setShouldAutoStart(false);
  };

  const handleConversationStart = () => {
    setShouldAutoStart(false); // Connection started, no need to auto-start anymore
    if (onConversationStart) {
      onConversationStart();
    }
  };

  const handleConversationEnd = () => {
    if (onConversationEnd) {
      onConversationEnd();
    }
    // Optionally close the modal when conversation ends
    // setIsExpanded(false);
  };

  const handleError = (error) => {
    setShouldAutoStart(false); // Error occurred, reset auto-start
    if (onError) {
      onError(error);
    }
  };

  return (
    <>
      <MinimizedView 
        onClick={handleToggle}
        isExpanded={isExpanded}
      />
      
      {isExpanded && (
        <ExpandedModal onClose={handleClose}>
          <WebRTCDemo 
            userName={userName}
            autoStart={shouldAutoStart}
            onConversationStart={handleConversationStart}
            onConversationEnd={handleConversationEnd}
            onError={handleError}
          />
        </ExpandedModal>
      )}
    </>
  );
};

HeaderDemoWidget.propTypes = {
  userName: PropTypes.string,
  onConversationStart: PropTypes.func,
  onConversationEnd: PropTypes.func,
  onError: PropTypes.func
};

export default HeaderDemoWidget;